import { Component, Input, OnInit } from '@angular/core';
import { CompaniesService } from '../../../../services/companies.service';
import { ClientNote } from '../../../../models/client';
import { BaseComponent } from '../../../../components/base/base.component';

@Component({
  selector: 'lib-client-note-start',
  templateUrl: './client-note-start.component.html',
  standalone: false
})
export class ClientNoteStartComponent extends BaseComponent implements OnInit {
  @Input() clientCode: string;
  clientNote: ClientNote;

  constructor(public companyService: CompaniesService) {
    super();
  }

  ngOnInit(): void {
    this.companyService.getActiveClientNote(this.clientCode).subscribe(note => {
      this.clientNote = note;
    });
  }
}
